import * as React from 'react'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Button, Divider, FormControl, FormHelperText, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import WebService from '@util/webService'
import useAlert from '@hooks/useAlert'
import useIndicator from '@hooks/useIndicator'
import { truncate } from '@util/helper'

// 강좌 지정 안 함
const NO_LECTURE = -1

const ManagerChatPartSetting = ({ record, dialogHandler, callback, setCloseHandler }) => {
  const { alert, renderAlert } = useAlert()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const schola = useSelector(state => state.scholaReducer)

  const [lectures, set_lectures] = useState([])
  const [loaded, set_loaded] = useState(false)
  const [lectureId, set_lectureId] = useState(Number(record.lectureId ?? NO_LECTURE))

  const handleClose = () => {
    dialogHandler[1](false)
  }

  // 종료되지 않은 학기 목록
  const fetchSmsts = async () => {
    const resp = await WebService.get(`/smst/not/closed/${schola.id}`)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.records)
  }

  // 여러 학기의 강좌를 한 번에 조회
  const fetchLectures = async smstIds => {
    const resp = await WebService.post('/lecture/smstids', smstIds)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.records)
  }

  const onLoad = async () => {
    openIndicator()
    try {
      const smstList = await fetchSmsts()
      if(!smstList || smstList.length === 0) {
        return
      }
      const list = await fetchLectures(smstList.map(r => r.id))
      if(!list) {
        return
      }
      // 푸시 메시지 화면과 같은 순서: 학기 단계 순, 같은 학기 안에서는 강좌명 순
      list.forEach(l => {
        const smst = smstList.find(s => s.id === l.smstId)
        l.gisu = smst?.gisu
        l.smstPhase = smst?.phase
      })
      list.sort((a, b) => a.smstPhase - b.smstPhase || a.title.localeCompare(b.title))
      set_lectures(list)
    }
    finally {
      closeIndicator()
      set_loaded(true)
    }
  }

  const onSave = async () => {
    const url = `/chat/update/chat/${record.id}/lecture/${lectureId}/school/${schola.id}`
    openIndicator()
    const resp = await WebService.post(url)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    alert('저장되었습니다.', () => {
      handleClose()
      callback?.()
    })
  }

  // 현재 지정된 강좌가 목록(종료되지 않은 학기)에 없으면 선택값을 비워 둠
  const inList = lectureId === NO_LECTURE || lectures.some(l => l.id === lectureId)
  const selectValue = loaded && inList ? lectureId : ''
  const changed = lectureId !== Number(record.lectureId ?? NO_LECTURE)

  useEffect(() => {
    if(setCloseHandler) {
      setCloseHandler(handleClose)
    }
  }, [setCloseHandler])

  useEffect(() => {
    onLoad()
  }, [record.id])

  return (
    <div>
      {renderAlert()}
      {renderIndicator()}

      <div style={{ marginBottom: 16 }}>
        <Typography variant="body2" color="text.secondary">작성자</Typography>
        <Typography variant="body1" style={{ marginBottom: 8 }}>{record.userAlias}</Typography>
        <Typography variant="body2" color="text.secondary">문의 내용</Typography>
        <Typography variant="body1">{truncate(record.content, 100)}</Typography>
      </div>

      <Divider style={{ marginBottom: 20 }} />

      <FormControl fullWidth>
        <InputLabel id="chat-lecture">강좌</InputLabel>
        <Select
          labelId="chat-lecture"
          label="강좌"
          value={selectValue}
          onChange={e => set_lectureId(Number(e.target.value))}
        >
          <MenuItem value={NO_LECTURE}>지정 안함</MenuItem>
          {lectures.map(l => (
            <MenuItem key={l.id} value={l.id}>
              {l.gisu} 기 / {l.title}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>
          {loaded && !inList
            ? '현재 지정된 강좌는 종료된 학기의 강좌입니다. 다른 강좌를 선택하거나 지정 안함으로 바꿀 수 있습니다.'
            : '강좌를 지정하면 해당 강좌의 강사도 이 문의를 보고 답변할 수 있습니다.'}
        </FormHelperText>
      </FormControl>

      <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 24 }}>
        <Button variant="outlined" onClick={handleClose}>닫기</Button>
        <Button variant="contained" onClick={onSave} disabled={!changed || selectValue === ''}>저장</Button>
      </div>
    </div>
  )
}

export default ManagerChatPartSetting
